export const TIME_UNTIL_VALID_BLUR_MS = 1_000;
